<template>
    <div>

        <div  style="padding: 25px 15px 0 15px;display: flex;" v-for="(item,index) in helpList" :key="item.index">
            <img :src="url" alt="">
            <div class="flex-column-space-between" style="margin-left: 30px;">
                <p class="name">{{ item.name }}</p>
                <p class="helptotal">帮扶总计：{{ item.total }}</p>
            </div>
            <div class="helping">
                正在帮扶：{{ item.ing }}
            </div>
        </div>
        
        
    </div>

</template>
<script>
export default{
    data() {
    return {
      url: require('@/assets/pic/teamicon.png'),
      helpList:[
        {
            name:'佐助',
            total:'60',
            ing:'65'
        },
 
        
        
      

      ]
    }
  }
}
</script>
<style scoped>
.text{
margin-top: 15px;
font-size: 22px;
font-weight: 500;
letter-spacing: 0px;
line-height: 31.86px;
color: rgba(51, 51, 51, 1);
}
.college-select {
width: 150px;
/* height: 35px; */
}
.name{

font-size: 18px;
font-weight: 500;

line-height: 26.06px;
color: rgba(51, 51, 51, 1);


}
.helptotal{

/** 文本1 */
font-size: 16px;
font-weight: 500;

line-height: 23.17px;
color: rgba(102, 102, 102, 0.8);


}
.helping{
    text-align: center;
    margin: auto;
    left: 245px;

font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
line-height: 26.06px;
color: rgba(67, 67, 67, 1);


}
</style>